module.exports = __webpack_public_path__ + "static/media/deer-rudolph.5a50d72d.svg";